import {
    NOTIFICATIONS_OPEN_SYSTEM,
    NOTIFICATIONS_CLOSE_SYSTEM,
    NOTIFICATIONS_OPEN_VALIDATION,
    NOTIFICATIONS_CLOSE_VALIDATION
} from './constants';

export const openSystemNotification = (data) => ({
    type: NOTIFICATIONS_OPEN_SYSTEM,
    payload: data
});

export const closeSystemNotification = () => ({
    type: NOTIFICATIONS_CLOSE_SYSTEM
});

export const openValidationNotification = (data) => ({
    type: NOTIFICATIONS_OPEN_VALIDATION,
    payload: data
});

export const closeValidationNotification = () => ({
    type: NOTIFICATIONS_CLOSE_VALIDATION
});
